import { DialogActions, DialogContent } from '@mui/material';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { uniqBy } from 'lodash-es';
import PropTypes from 'prop-types';
import React from 'react';
import { useForm } from 'react-hook-form';
import { MdArrowBackIos, MdClose } from 'react-icons/md';
import StyledBoldTypography from '../Styled/StyledBoldTypography';
import StyledContainedButton from '../Styled/StyledContainedButton';
import StyledRoundIconButton from '../Styled/styledRoundIconButton';
import StyledTextArea from '../Styled/StyledTextArea';
import StyledTextButton from '../Styled/StyledTextButton';
import StyledToggleButton from '../Styled/StyledToggleButton';
import VolunteeringOpportunityModel from './volunteeringOpportunityModel';

function VolunteeringApplicationForm(props) {
  const { fullScreen, opportunity = null, onSubmit, onClose, onBack } = props;
  const {
    register,
    setValue,
    getValues,
    handleSubmit,
    formState: { errors },
  } = useForm();

  register('skillIds', { value: [], required: 'Select at least one skill' });

  const mandatorySkills = opportunity?.mandatorySkills || [];
  const optionalSkills = opportunity?.optionalSkills || [];
  
  const allSkills = uniqBy(
    [...mandatorySkills, ...optionalSkills],
    'id'
  );
  

  const handleSkillToggle = (skill, selected) => {
    setValue(
      'skillIds',
      selected
        ? [...getValues('skillIds'), skill.id]
        : getValues('skillIds').filter((id) => id !== skill.id)
    );
  };

  const onFormSubmit = () => {
    onSubmit(getValues());
  };

  return (
    <form onSubmit={handleSubmit(onFormSubmit)}>
      <DialogContent>
        <Stack gap={1}>
          <Stack>
            <StyledTextArea
              {...register('message', { required: 'Please fill in the brief' })}
              rows="4"
              autoFocus
              placeholder="Please provide a brief description about your relevant experience, number of hours you can contribute towards this casue etc."
            />
            <Typography variant="caption" color="error">
              {errors && errors.message?.message}
            </Typography>
          </Stack>

          <StyledBoldTypography variant="h6">
            Do you have any of the following skills?
          </StyledBoldTypography>

          <Stack gap={1}>
            <Stack direction="row" flexWrap="wrap" gap={1}>
              {allSkills.map((skill) => (
                <StyledToggleButton
                  key={skill.id}
                  label={skill.skill_title}
                  onToggle={(selected) => handleSkillToggle(skill, selected)}
                />
              ))}
            </Stack>
            <Typography variant="caption" color="error">
              {errors && errors.skillIds?.message}
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack
          direction="row"
          justifyContent="flex-end"
          gap={1}
          className="mt-4">
          <StyledTextButton type="button" onClick={onClose}>
            <Typography variant="button">Cancel</Typography>
          </StyledTextButton>
          <StyledContainedButton type="submit">Submit</StyledContainedButton>
        </Stack>
      </DialogActions>
    </form>
  );
}

VolunteeringApplicationForm.propTypes = {
  fullScreen: PropTypes.bool.isRequired,
  opportunity: VolunteeringOpportunityModel,
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
};

export default VolunteeringApplicationForm;
